module.exports = __webpack_public_path__ + "static/dropdown-688cf85eba6915f54eb526b7eed5f1d4.jpg";